import * as uuid from 'uuid';

export const generateUuidV4 = (): string => uuid.v4();
